import styled from 'styled-components';
import { useCallback, useState, useRef } from 'react';
import { fullWidthCellClassName } from 'customer-data-properties/utils/fullWidthCellClassName';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useSingletonTooltip } from '../tooltip/SingletonTooltipContext';
import { jsx as _jsx } from "react/jsx-runtime";
const NoWrapDiv = styled.div.withConfig({
  displayName: "TruncateDiv__NoWrapDiv"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;&:has( .", ",[data-classname~='", "'] ){width:100%;}", ""], fullWidthCellClassName, fullWidthCellClassName, ({
  $rightAligned
}) => $rightAligned ? 'text-align: right; width: 100%;' : '');
const TruncateDiv = ({
  rightAligned,
  children
}) => {
  const singletonContext = useSingletonTooltip();
  const [isTruncated, setIsTruncated] = useState(false);
  const elementRef = useRef(null);
  const {
    showTooltip,
    hideTooltip
  } = singletonContext || {};
  const TooltipContent = useCallback(() => /*#__PURE__*/_jsx(View, {
    children: children
  }), [children]);
  const handleMouseEnter = useCallback(e => {
    const target = e.currentTarget;
    const truncated = target.scrollWidth > target.clientWidth;
    if (showTooltip) {
      if (truncated) {
        showTooltip(target, TooltipContent, {
          maxInlineSize: '500px'
        });
      }
    } else {
      setIsTruncated(truncated);
    }
  }, [showTooltip, TooltipContent]);
  const handleMouseLeave = useCallback(() => {
    if (hideTooltip) {
      hideTooltip();
    }
  }, [hideTooltip]);
  const content =
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsx(NoWrapDiv, {
    ref: elementRef,
    "data-test-id": "truncated-object-label",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    $rightAligned: rightAligned,
    children: children
  });
  if (singletonContext) {
    return content;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    Content: TooltipContent,
    disabled: !isTruncated,
    maxInlineSize: "500px",
    children: content
  });
};
export default TruncateDiv;